export default __webpack_public_path__ + "static/media/blog-fire-pit-002.400edea6.jpg";